import { AgentsRoute } from "./routes/agents";
import { ChannelsRoute } from "./routes/channels";
import { KnowledgeSourcesRoute } from "./routes/knowledge-sources";
import { UsersRoute } from "./routes/users";
import { Navigate } from "react-router-dom";

export const AI_STUDIO_ROUTES = {
  aistudioRoot: {
    key: "ai-studio-root",
    path: "/aistudio",
    element: <Navigate to="/aistudio/agents" />
  },
  agents: {
    key: "ai-studio-agents",
    title: "Agents",
    path: "/aistudio/agents",
    element: <AgentsRoute />
  },
  agentDetail: {
    key: "ai-studio-agent-detail",
    title: "Agent",
    path: "/aistudio/agents/:agentId",
    element: <AgentsRoute />
  },
  channels: {
    key: "ai-studio-channels",
    title: "Channels",
    path: "/aistudio/channels",
    element: <ChannelsRoute />
  },
  channelDetail: {
    key: "ai-studio-channel-detail",
    title: "Channel",
    path: "/aistudio/channels/:channelId",
    element: <ChannelsRoute />
  },
  knowledgeSources: {
    key: "ai-studio-knowledge-sources",
    title: "Knowledge Sources",
    path: "/aistudio/knowledge",
    element: <KnowledgeSourcesRoute />
  },
  knowledgeSourceDetail: {
    key: "ai-studio-knowledge-source-detail",
    title: "Knowledge Source",
    path: "/aistudio/knowledge/:knowledgeSourceId",
    element: <KnowledgeSourcesRoute />
  },
  users: {
    key: "ai-studio-users",
    title: "Users",
    path: "/aistudio/users",
    element: <UsersRoute />
  },
  userDetail: {
    key: "ai-studio-user-detail",
    title: "User",
    path: "/aistudio/users/:userId",
    element: <UsersRoute />
  }
};
